































































































































import {
  EventManagementEventService as eventApi,
  EventManagementMemberDTO,
} from "@/common/api";
import QNotify from "@/common/qNotify";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import CameraComponent from "@/components/admin/event/cameraComponent.vue";
import MemberEventNumberQrCodeComponent from "@/components/admin/member/memberEventNumberQrCodeComponent.vue";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "EventReceptComponent",
  components: {
    QSearch,
    QTableHeader,
    MemberEventNumberQrCodeComponent,
    CameraComponent,
  },
})
export default class EventReceptComponent extends Vue {
  public get title(): string {
    const today = new Date();
    const todayFormat = moment(today.toUTCString()).format("YYYY-MM-DD");
    return `${todayFormat} 来場者一覧`;
  }

  public headers = [
    { id: "event_number", name: "抽選番号", order: "asc" },
    { id: "full_name", name: "氏名", order: "" },
    { id: "tel", name: "TEL" },
    { id: "id", name: "会員番号", order: "" },
    { id: "eventItems", name: "申込" },
    { id: "", name: "" },
  ];

  public initialSearch = {
    eventNumber: null,
    fullName: null,
    tel: null,
    memberId: null,
    sort: "event_number",
    direction: "asc",
    perPage: 9999, // Show all members
    currentPage: 1,
  };

  public searchParams: any = {};

  public members: EventManagementMemberDTO[] = [];

  public mounted() {
    this.initSearch();
    this.filterData();
  }

  public initSearch(): void {
    const query = this.$router.currentRoute.query;
    this.searchParams = {
      ...this.initialSearch,
      ...query,
    };
  }

  public filterData(clear = false, addition = {}): void {
    let { name, params, query } = this.$router.currentRoute;
    if (clear) {
      query = {};
    }
    query = {
      ...this.searchParams,
      ...query,
      ...addition,
    };

    this.$router.replace({ name, params, query });
    this.doSearch(query);
  }

  public doSearch(query: any = {}): void {
    this.getList(query);
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public async getList(query) {
    let message: any;
    try {
      const { data } = await eventApi.adminEventRecept(query);
      this.members = data.members;
    } catch (error) {
      message = error.body.message;
      QNotify.error({
        text: message,
      });
    }
  }

  public resetSearch() {
    this.clearSearchParams();
    this.filterData(true);
  }

  public clearSearchParams() {
    this.searchParams = { ...this.initialSearch };
  }

  public cancel() {
    this.$router.back();
  }

  public showEventNumberQRCode(item) {
    (
      this.$refs
        .memberEventNumberQrCodeComponent as MemberEventNumberQrCodeComponent
    ).show(item.event_hash_url);
  }

  public showCamera() {
    (this.$refs.cameraPopup as CameraComponent).show();
  }

  public handleCameraError(errorMessage: string): void {
    QNotify.error({
      text: errorMessage,
    });
  }

  public handleQrDetected(qrData: string) {
    try {
      const isMemberUrl = qrData.includes("?id=");
      const [first, ...rest] = isMemberUrl
        ? qrData.split("?id=")
        : qrData.split("/");
      const eventHash = isMemberUrl ? atob(rest.join("")) : rest.join("/");
      if (eventHash) {
        this.updateEventCheckin(eventHash);
      }
    } catch (error) {
      console.error("QRコード処理エラー:", error);
      QNotify.error({
        text: "QRコードの処理中にエラーが発生しました。",
      });
    }
  }

  public async updateEventCheckin(eventHash) {
    let result;
    try {
      result = await eventApi.adminEventSettingCheckin({
        eventHash,
      });

      if (result.status == "success") {
        QNotify.success({
          text: "チェックインしました。",
        });
        this.resetSearch();
      }
    } catch (error) {
      result = error;
      QNotify.error({
        text: result.body.message,
      });
    }
  }

  // メンバーごとのイベントグループ化
  public groupEventsByMember(
    member: any,
  ): Array<{ id: number; title: string; items: string[] }> {
    const groups: Record<
      number,
      { id: number; title: string; items: string[] }
    > = {};

    for (const entry of member.event_entries ?? []) {
      const eventId = entry.eventId;
      const eventName = entry.eventTitle;
      const code = entry.eventItemCode;

      if (!eventId || !code) { continue; }

      if (!groups[eventId]) {
        groups[eventId] = {
          id: eventId,
          title: eventName,
          items: [],
        };
      }

      groups[eventId].items.push(code);
    }

    return Object.values(groups);
  }
}
